'use client';

import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import NewSpeakerSection from './NewSpeakersSection';

/* ---------- DATA ---------- */

const upcomingEvents = [
  // {
  //   href: 'https://luma.com/memeconriyadh',
  //   src: '/images/memecon-riyadh.webp',
  //   alt: 'memecon-riyadh',
  // },
  {
    href: 'https://luma.com/lkgbgtzt',
    src: '/images/memecon-singapore.webp',
    alt: 'memecon-singapore-2026',
  },
  {
    href: 'https://luma.com/MemeConEvents?k=c',
    src: '/images/memecon-luma-abudhabi.webp',
    alt: 'memecon-luma-abudhabi2026',
  },
];

const pastEvents = [
  // {
  //   href: 'https://luma.com/memeconriyadh',
  //   src: '/images/memecon-riyadh.webp',
  //   alt: 'memecon-riyadh',
  // },
  {
    href: 'https://luma.com/MemeConMeetupAbuDhabi',
    src: '/images/memecon-abudhabi-luma.webp',
    alt: 'memecon-abudhabi-luma',
  },
  
  {
    href: 'https://luma.com/h0zwsenc',
    src: '/images/memecon-singapore-luma.webp',
    alt: 'memecon-singapore-luma',
  },
  {
    href: 'https://luma.com/MemeConEvents?k=c',
    src: '/images/meme-frenzy-event.webp',
    alt: 'meme-frenzy-event',
  },
  

];

/* ---------- COMPONENT ---------- */

export default function EventsSection() {
  return (
    <section data-component-id="src/app/EventsSection.tsx:58:4" data-component-path="src/app/EventsSection.tsx" data-component-line="58" data-component-end-line="162" data-component-file="EventsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22events%22%2C%22className%22%3A%22w-full%20bg-background-main%20py-%5B40px%5D%20sm%3Apy-%5B56px%5D%20md%3Apy-%5B64px%5D%20lg%3Apy-%5B80px%5D%20bg-no-repeat%20bg-cover%20bg-center%22%7D"
  id="events"
  className="w-full bg-background-main py-[40px] sm:py-[56px] md:py-[64px] lg:py-[80px] bg-no-repeat bg-cover bg-center"
  style={{
    backgroundImage: "url('/images/events-initiatives.svg')",
  }}
>
      <div data-component-id="src/app/EventsSection.tsx:65:6" data-component-path="src/app/EventsSection.tsx" data-component-line="65" data-component-end-line="161" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1440px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-%5B56px%5D%22%7D" className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-[56px]">
        <div data-component-id="src/app/EventsSection.tsx:66:8" data-component-path="src/app/EventsSection.tsx" data-component-line="66" data-component-end-line="160" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-%5B30px%5D%20items-center%20w-full%22%7D" className="flex flex-col gap-[30px] items-center w-full">

          {/* Section Header */}
          <div data-component-id="src/app/EventsSection.tsx:69:10" data-component-path="src/app/EventsSection.tsx" data-component-line="69" data-component-end-line="76" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%22%7D" className="text-center">
            <h2 data-component-id="src/app/EventsSection.tsx:70:12" data-component-path="src/app/EventsSection.tsx" data-component-line="70" data-component-end-line="72" data-component-file="EventsSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B28px%5D%20sm%3Atext-%5B32px%5D%20md%3Atext-%5B36px%5D%20lg%3Atext-%5B42px%5D%20font-semibold%20text-text-muted%20font-%5B'%5D%22%2C%22textContent%22%3A%22Events%20%26%20Initiatives%22%7D" className="text-[28px] sm:text-[32px] md:text-[36px] lg:text-[42px] font-semibold text-text-muted font-[']">
              Events & Initiatives
            </h2>
            <h3 data-component-id="src/app/EventsSection.tsx:73:12" data-component-path="src/app/EventsSection.tsx" data-component-line="73" data-component-end-line="75" data-component-file="EventsSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B18px%5D%20sm%3Atext-%5B20px%5D%20md%3Atext-%5B22px%5D%20lg%3Atext-%5B24px%5D%20font-semibold%20text-text-light%20font-%5B'%5D%20mt-2%22%2C%22textContent%22%3A%22Upcoming%20Events%22%7D" className="text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] font-semibold text-text-light font-['] mt-2">
              Upcoming Events
            </h3>
          </div>

          {/* Upcoming Events Grid */}
          <div data-component-id="src/app/EventsSection.tsx:79:10" data-component-path="src/app/EventsSection.tsx" data-component-line="79" data-component-end-line="98" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20md%3Agrid-cols-2%20gap-4%20sm%3Agap-6%20justify-items-center%22%7D" className="grid grid-cols-2 md:grid-cols-2 gap-4 sm:gap-6 justify-items-center">
          {/* <div className="flex flex-wrap justify-center gap-4 sm:gap-6"> */}
            {upcomingEvents.map((event, index) => (
              <a data-component-id="src/app/EventsSection.tsx:82:14" data-component-path="src/app/EventsSection.tsx" data-component-line="82" data-component-end-line="96" data-component-file="EventsSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
                key={index}
                href={event.href}
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                <Image data-component-id="src/app/EventsSection.tsx:88:16" data-component-path="src/app/EventsSection.tsx" data-component-line="88" data-component-end-line="95" data-component-file="EventsSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-%5B160px%5D%20sm%3Aw-%5B200px%5D%20md%3Aw-%5B260px%5D%20lg%3Aw-%5B320px%5D%20h-auto%20object-cover%20rounded-%5B20px%5D%22%7D"
                  src={event.src}
                  alt={event.alt}
                  width={320}
                  height={320}
                  className="w-[160px] sm:w-[200px] md:w-[260px] lg:w-[320px] h-auto object-cover rounded-[20px]"
                  unoptimized
                />
              </a>
            ))}
          </div>

          {/* Register Button */}
          <Link data-component-id="src/app/EventsSection.tsx:101:10" data-component-path="src/app/EventsSection.tsx" data-component-line="101" data-component-end-line="109" data-component-file="EventsSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22https%3A%2F%2Fluma.com%2FMemeConEvents%3Fk%3Dc%22%7D"
            href="https://luma.com/MemeConEvents?k=c"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <button data-component-id="src/app/EventsSection.tsx:106:12" data-component-path="src/app/EventsSection.tsx" data-component-line="106" data-component-end-line="108" data-component-file="EventsSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22capitalize%20px-5%20py-3%20text-white%20text-sm%20sm%3Atext-base%20font-semibold%20shadow-md%20rounded-2xl%20bg-%5B%23FF00B6%5D%20hover%3Aopacity-90%20transition%20w-full%20max-w-%5B320px%5D%22%2C%22textContent%22%3A%22Register%20here%22%7D" className="capitalize px-5 py-3 text-white text-sm sm:text-base font-semibold shadow-md rounded-2xl bg-[#FF00B6] hover:opacity-90 transition w-full max-w-[320px]">
              Register here
            </button>
          </Link>

          {/* New Speakers */}
          {/* <NewSpeakerSection /> */}

          {/* Past Event Label */}
          <h3 data-component-id="src/app/EventsSection.tsx:115:10" data-component-path="src/app/EventsSection.tsx" data-component-line="115" data-component-end-line="117" data-component-file="EventsSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B18px%5D%20sm%3Atext-%5B20px%5D%20md%3Atext-%5B22px%5D%20lg%3Atext-%5B24px%5D%20font-semibold%20text-center%20text-text-light%20font-%5B'%5D%20mt-8%22%2C%22textContent%22%3A%22Past%20Events%22%7D" className="text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] font-semibold text-center text-text-light font-['] mt-8">
            Past Events
          </h3>

          {/* Past Event Cards */}
          {/* <div className="flex flex-wrap justify-center gap-4 sm:gap-6"> */}
          <div data-component-id="src/app/EventsSection.tsx:121:10" data-component-path="src/app/EventsSection.tsx" data-component-line="121" data-component-end-line="152" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20md%3Agrid-cols-3%20gap-4%20sm%3Agap-6%20justify-items-center%22%7D" className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 justify-items-center">

            {pastEvents.map((event, index) =>
              event.href ? (
                <a data-component-id="src/app/EventsSection.tsx:125:16" data-component-path="src/app/EventsSection.tsx" data-component-line="125" data-component-end-line="139" data-component-file="EventsSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
                  key={index}
                  href={event.href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  <Image data-component-id="src/app/EventsSection.tsx:131:18" data-component-path="src/app/EventsSection.tsx" data-component-line="131" data-component-end-line="138" data-component-file="EventsSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-%5B200px%5D%20sm%3Aw-%5B260px%5D%20md%3Aw-%5B300px%5D%20lg%3Aw-%5B340px%5D%20sm%3Ah-%5B150px%5D%20lg%3Ah-%5B310px%5D%20object-cover%20rounded-%5B16px%5D%22%7D"
                    src={event.src}
                    alt={event.alt}
                    width={320}
                    height={320}
                    className="w-[200px] sm:w-[260px] md:w-[300px] lg:w-[340px] sm:h-[150px] lg:h-[310px] object-cover rounded-[16px]"
                    unoptimized
                  />
                </a>
              ) : (
                <Image data-component-id="src/app/EventsSection.tsx:141:16" data-component-path="src/app/EventsSection.tsx" data-component-line="141" data-component-end-line="149" data-component-file="EventsSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-%5B200px%5D%20sm%3Aw-%5B260px%5D%20md%3Aw-%5B300px%5D%20lg%3Aw-%5B340px%5D%20h-auto%20object-cover%20rounded-%5B16px%5D%22%7D"
                  key={index}
                  src={event.src}
                  alt={event.alt}
                  width={320}
                  height={320}
                  className="w-[200px] sm:w-[260px] md:w-[300px] lg:w-[340px] h-auto object-cover rounded-[16px]"
                  unoptimized
                />
              )
            )}
          </div>

          {/* Host Event Button */}
          <Link data-component-id="src/app/EventsSection.tsx:155:10" data-component-path="src/app/EventsSection.tsx" data-component-line="155" data-component-end-line="159" data-component-file="EventsSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fcontact%22%7D" href="/contact">
            <button data-component-id="src/app/EventsSection.tsx:156:12" data-component-path="src/app/EventsSection.tsx" data-component-line="156" data-component-end-line="158" data-component-file="EventsSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22px-5%20py-3%20text-white%20text-sm%20sm%3Atext-base%20font-semibold%20shadow-md%20rounded-2xl%20bg-%5B%23FF00B6%5D%20hover%3Aopacity-90%20transition%20w-full%20max-w-%5B320px%5D%22%2C%22textContent%22%3A%22Host%20an%20Event%20With%20Us%22%7D" className="px-5 py-3 text-white text-sm sm:text-base font-semibold shadow-md rounded-2xl bg-[#FF00B6] hover:opacity-90 transition w-full max-w-[320px]">
              Host an Event With Us
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}
